import { RentStage } from '@tallo/property';

export enum PropertyLeadsFilter {
  ALL = 'All',
  PENDING = 'Pending',
  ACCEPTED = 'Accepted',
  RESCHEDULING = 'Rescheduling',
  SHOWING_COMPLETED = 'Showing Completed',
  DECLINED = 'Declined',
  CANCELED = 'Canceled',
  EXPIRED = 'Expired',
}

export const leadsFilterStages = new Map<PropertyLeadsFilter, RentStage[]>([
  [PropertyLeadsFilter.PENDING, [RentStage.SHOWING_REQUESTED]],
  [PropertyLeadsFilter.ACCEPTED, [RentStage.SHOWING_CONFIRMED]],
  [PropertyLeadsFilter.DECLINED, [RentStage.SHOWING_DECLINED]],
  [
    PropertyLeadsFilter.RESCHEDULING,
    [RentStage.SHOWING_RESCHEDULE_REQUESTED_BY_OWNER, RentStage.SHOWING_RESCHEDULE_REQUESTED_BY_RENTER],
  ],
  [PropertyLeadsFilter.SHOWING_COMPLETED, [RentStage.SHOWING_COMPLETED, RentStage.APPLICATION_INVITE_SENT]],
  [
    PropertyLeadsFilter.CANCELED,
    [
      RentStage.SHOWING_CANCELLED_BY_OWNER,
      RentStage.SHOWING_CANCELLED_BY_RENTER,
      RentStage.STOPPED_PROPERTY_RENTED_OUT,
    ],
  ],
  [PropertyLeadsFilter.EXPIRED, [RentStage.SHOWING_REQUEST_IGNORED_BY_OWNER]],
]);
